import { take, fork, select, call, put, takeLatest } from 'redux-saga/effects';
import { isServer } from '@utils/helper';
import {
  getPortfolioApi,
  updateViewCountByProjectsApi,
} from 'services/portfolioApi';
import { GET_PORTFOLIO, UPDATE_VIEW_COUNT_BY_PROJECTS } from './slice';

export function* watchAndLog() {
  while (true) {
    try {
      const styleConsole =
        'background: yellow; font-weight: bold; color: #40a9ff8c;';
      const action = yield take('*');
      const state = yield select();
      if (action.type !== '@@router/LOCATION_CHANGE') {
        console.group(action.type);
        console.log('%cBefore State', styleConsole, state);
        console.info('%cDispatching', styleConsole, action);
        console.log('%cNext State', styleConsole, state);
        console.groupEnd();
      }
    } catch {}
  }
}

export function* getPortfolio({ payload }: any) {
  try {
    const { slug, menuCollectionSelected } = payload;
    const response = yield call(getPortfolioApi, slug);
    yield put(
      GET_PORTFOLIO.success({
        portfolio: response.data.data,
        menuCollectionSelected,
      }),
    );
  } catch (err) {
    console.log(err);
    yield put(GET_PORTFOLIO.failure());
  }
}

export function* updateViewCountByProjects({ payload }: any) {
  try {
    const response = yield call(updateViewCountByProjectsApi, payload);
    yield put(UPDATE_VIEW_COUNT_BY_PROJECTS.success(response.data.data));
  } catch (err) {
    console.log(err);
    yield put(UPDATE_VIEW_COUNT_BY_PROJECTS.failure());
  }
}

const homeSagas: any = [
  takeLatest(GET_PORTFOLIO.TRIGGER, getPortfolio),
  takeLatest(UPDATE_VIEW_COUNT_BY_PROJECTS.TRIGGER, updateViewCountByProjects),
];

if (!isServer && process.env.NODE_ENV === 'development')
  homeSagas.push(fork(watchAndLog));

export default homeSagas;
